import React from 'react';
import { ButtonBase } from '@mui/material';
import {
	RemoveCircle as RemoveCircleIcon,
	AddCircleOutline as AddCircleIcon,
} from '@mui/icons-material';

interface RemoveRowButtonProps {
	onClick(): void;
	disabled?: boolean;
}

export const RemoveRowButton = (props: RemoveRowButtonProps) => {
	const { onClick, disabled } = props;

	return (
		<ButtonBase
			data-cy="removeButton"
			style={{ borderRadius: '50%' }}
			onClick={onClick}
			disableTouchRipple
			disabled={disabled}>
			<RemoveCircleIcon fontSize="large" style={{ color: '#DADADA' }} />
		</ButtonBase>
	);
};

interface AddRowButtonProps {
	onClick(): void;
	disabled?: boolean;
}

export const AddRowButton = (props: AddRowButtonProps) => {
	const { onClick, disabled } = props;

	return (
		<ButtonBase
			data-cy="addButton"
			style={{ borderRadius: '50%' }}
			onClick={onClick}
			disableTouchRipple
			disabled={disabled}>
			<AddCircleIcon fontSize="large" style={{ color: '#DADADA' }} />
		</ButtonBase>
	);
};
